import { render } from "./ComingSoonPanel.vue?vue&type=template&id=5547df9a&scoped=true"
import script from "./ComingSoonPanel.vue?vue&type=script&lang=js"
export * from "./ComingSoonPanel.vue?vue&type=script&lang=js"

import "./ComingSoonPanel.vue?vue&type=style&index=0&id=5547df9a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5547df9a"]])

export default __exports__